import React from 'react';
import { PropTypes } from 'prop-types';
import image from '../../../../assets/images/defaults/loader.gif';
import './SpinnerDashboards.scss';

export const SpinnerDashboards = ({
 isActive, isAbsolute, isSmall, isWithoutText
}) => (
  <>
    {isActive && (
      <div
        className={`spinner-wrapper-dahboard${isAbsolute ? '  is-absolute' : ''}${
          (isSmall && ' is-small') || ''
        }`}
      >
        <div className='app-spinner-dahboard'>
          <img src={image} alt='...' className='spinner-img-dahboard' />
          {!isWithoutText && <span className='fz-15px'>Dashboard Loading Please Wait ...</span>}
        </div>
      </div>
    )}
  </>
);
SpinnerDashboards.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isAbsolute: PropTypes.bool,
  isSmall: PropTypes.bool,
  isWithoutText: PropTypes.bool,
};
SpinnerDashboards.defaultProps = {
  isAbsolute: false,
  isSmall: false,
  isWithoutText: false,
};
